import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import myProject1 from "../../Assets/Projects/my-project-1.jpg";
import myProject2 from "../../Assets/Projects/my-project-2.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={myProject1}
              isBlog={false}
              title="AI Resume Analyzer"
              description="Built an AI-powered tool that uses artificial intelligence and NLP to analyze resumes against job descriptions. It identifies skill gaps, improves ATS compatibility, and provides actionable feedback to enhance candidate selection chances."
              ghLink="https://github.com/Anmol7091/ai-resume-analyzer"
              demoLink="https://ai-resume-analyzer-phi-liard.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={myProject2}
              isBlog={false}
              title="Social Media Application"
              description="A Social Media Web App built with React 19 and Vite, delivering a fast and responsive user experience. It allows users to create and view posts with content, reactions, and hashtags, using the React Context API for state management. Styled with Bootstrap 5 and React Icons, the app follows a modular, component-based architecture for scalability and easy maintenance."
              ghLink="https://github.com/Anmol7091/Social-Media-Application"
              demoLink="https://social-media-application-gules.vercel.app/#"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
